// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"2528": "f7d254855702","3508": "583ad977d3d9","3616": "2bd20f1d2224","4024": "c112b1859c50","484": "b42b0782113d","5918": "4d13735e9948","6863": "454c9f289029","9569": "a8269c7d8bd8",}[chunkId] + ".css"
}